import { Injectable } from '@angular/core';
import { SendMoneyService } from '../dashboard/send-money/send-money.service';

@Injectable({
  providedIn: 'root'
})
export class SendRequestMoneyService {

  request = null
  constructor(private sendMoneyService: SendMoneyService) { }

  assign(rec, purp, ack, amount){
    this.sendMoneyService.receiver = rec
    this.sendMoneyService.purpose = purp
    this.sendMoneyService.isAcknowlodgingRequest = ack
    this.sendMoneyService.requestedSendingAmount = amount
  }
}
